import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';
import DashboardContainer from './container/dashboardContainer/DashboardContainer.jsx';
import MilestoneClaimPopups from '../_shared/components/milestone-gift-modal/MilestoneClaimPopups.jsx';
import useMilestoneClaims from '../_shared/components/milestone-gift-modal/useMilestoneClaims.js';

const Home = () => {
	const currentUser = useSelector((state) => state.user.currentUser);
	const milestone = useMilestoneClaims(currentUser);

	if (!currentUser || !currentUser?.company) return <Spinner />;
	return (
		<>
			<MilestoneClaimPopups currentUser={currentUser} milestone={milestone} />
			<DashboardContainer currentUser={currentUser} />
		</>
	);
};

export default Home;
